export const COURSE_REVIEW_REVEAL_DELAY_MS = 500;
